import React from "react";
import "./Modal.css";

const Modal = ({ slide, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h1>{slide.title}</h1>
        <p>{slide.longDescription}</p>
        <button className="close-btn" onClick={onClose}>X</button>
      </div>
    </div>
  );
};

export default Modal;
